import { useState, useEffect } from "react";
import { ErrorContext } from "../../../utils/context/error";
import PropTypes from 'prop-types';
import Modal from "../../modal";
import { getArchiveInt, actualizaArchive } from "../../../services/archivos";

function ImageModal({ show, AreaI, AreaFId ,MensajeI, Tag, handleshow, handleFiltrar }) 
{
  const [areaId, setAreaId] = useState(0);
  const [archivoId, setArchivoId] = useState(0);
  const [descripcion, setDescripcion]= useState("");
  const [carpeta, setCarpeta]= useState("");
  const [Titulo, setTitulo] = useState("");
  const [habilita, setHabilita] = useState(false);
  const [area, setArea] = useState([]);
  const [validar, setValidar] = useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
   
  //----------  Boton Cancelar---------------------------
  const handleCancel = async () => 
    {
     handleshow(false);
    };
  
  //---------- Boton Aceptar ----------------------------
  const handleAceptar = async () => 
    {
       setHabilita(true);
       setShowToast(false);

       setValidar(false);
       if (areaId >0 && carpeta !=='')
        {  
          
          const response = await actualizaArchive(
           {
             areaId,
             archivoId,
             carpeta,
             descripcion,
             grupo:'VI',
             Tag,
           }
         );
         if (response) 
           {
            
             if (response.status === 200) 
              {
                if (Tag ===2)
                  handleFiltrar([]);
                else 
                  handleFiltrar(response?.data?.data[0]);
                handleshow(false);
                setValidar(false);
              } 
            else 
             {
              console.log(response.message)
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             }
          }
         else 
             {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             }
      }
      else
      setValidar(true);

      setHabilita(false);
      
    }   

//-------- Servicio por area e Id -----------------------
  const fillMessageInt = async (AreaId, MensajeI) => 
    {
       setShowToast(false);
       const response = await getArchiveInt(AreaId, MensajeI);
       if (response) 
        {
          if (response.status === 200) 
            {
               setDescripcion(response.data.data[0]?.Descripcion||"");
               setCarpeta(response.data.data[0]?.Carpeta||"");
               setAreaId(AreaI);
               setArchivoId(MensajeI);
         
               setArea(response.data.area);
            } 
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
        }
     };

  //-------------------------------------------------------
  useEffect(() => 
    {
      if (show) 
        {
         setDescripcion("");
         setCarpeta("");
         setAreaId(AreaI);
         setArchivoId(MensajeI);
     
         fillMessageInt(AreaI, MensajeI);
      
         if (Tag !== 0) 
          {
            if (Tag === 1) setTitulo("Editar Carpeta (" + MensajeI + ")");
            if (Tag === 2) setTitulo("Eliminar Carpeta (" + MensajeI + ")");
          } 
         else 
         {
           setArchivoId(0);
           setTitulo("Nueva Carpeta");
         }
        }
    }, [show]);

  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
            <div className="flex lg:w-[26rem]">
                <form noValidate className="flex flex-col w-full">
                    <div className="flex flex-col w-full h-full ">
                       <div className="w-full">
                          <label>Area</label>
                          <select id="area" name="area" value={areaId || 0} 
                                  onChange={(e) => setAreaId(e.target.value)} 
                                  label="Area" disabled={Tag === 2 || Tag === 1}
                                  className={`${validar && areaId === 0 ? `validar`: ""}`}>
                            <option value={0} disabled>
                               Seleccionar una Area...
                            </option>
                            {area.map((item) => 
                              {
                                return(
                                  <option key={item.AreaId} value={item.AreaId}>
                                      {item.NombreArea}
                                  </option>
                                );
                              }
                              )
                            }
                         </select>
                         {validar && areaId === 0 && (
                           <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                               * Campo Obligatorio.
                           </p>
                          )}
                       </div>
                       <div className="w-full mt-4">
                           <label>Nombre Carpeta</label>
                           <input type="text" name='searchid' value={carpeta || ""} placeholder="Nombre carpeta" 
                            onChange={(e)=> setCarpeta(e.target.value)}
                            autoComplete="off" 
                            disabled={Tag === 2 || Tag === 1}>
                          </input>
                       </div>
                       <div className="w-full mt-4">
                         <label>Mensaje</label>
                            <textarea name='searchid' value={descripcion || ""} placeholder="Ingresa un Mensaje" 
                                onChange={(e)=> setDescripcion(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2}>
                            </textarea>
                       </div>      
                </div>
                <div className="flex w-full gap-4 mt-6 justify-end">
                   <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                   <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                </div>
            </form>
        </div>                                             
      </Modal>
    </>
  );
}

ImageModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  MensajeI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default ImageModal;
